import { Component } from '@angular/core';
import { FieldAssignmentGridComponent } from '../shared/field-assignment-grid/field-assignment-grid.component';

@Component({
    selector: 'app-file-edifact',
    templateUrl: './file-edifact.component.html',
    styleUrls: ['./file-edifact.component.scss'],
    imports: [FieldAssignmentGridComponent]
})
export class FileEdifactComponent {

  constructor() {
  }

}
